<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.refresh')"
          type="button"
          @click="getAllList()"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-align-middle
            thead.thead-light
              tr
                th(rowspan=2 width="5%")
                  span(:title="$t('ui.id')" ) {{ $t('ui.id') }}
                th.text-center(rowspan=2 width="5%")
                  span(:title="$t('ui.cycle')" ) {{ $t('ui.cycle') }}
                th.text-center(rowspan=2 width="5%")
                  span(:title="$t('ui.criteria')" ) {{ $t('ui.criteria') }}
                th.text-center(colspan=7 width="5%")
                  span(:title="$tc('ui.day', 1)" ) {{ $tc('ui.day', 1) }}
                th.text-center(rowspan=2 width="5%")
                  span(:title="$t('ui.status')" ) {{ $t('ui.status') }}
                th.text-center(rowspan=2 width="5%")
                  span(:title="$t('ui.payout_method')" ) {{ $t('ui.payout_method') }}
                th.text-center(rowspan=2 width="5%" v-if="isEditAccess")
                  span(:title="$t('ui.action')" ) {{ $t('ui.action') }}
              tr
                template(v-for="x in Number(7)")
                  th.text-center(width="5%")
                    span(:title="x" ) {{ x }}
            tbody.clusterize-content
              tr(v-if="list.length == 0")
                td(colspan="19").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in loginList")
                tr
                  td(rowspan=2)
                    template(v-if="item.gamify_id == 'login'")
                      span(:title="$t('ui.daily_login')") {{ $t('ui.daily_login') }}
                    template(v-else)
                      span(:title="item.gamify_id.toUpperCase()") {{ item.gamify_id.toUpperCase() }}
                  td.text-center(rowspan=2)
                    span(:class="item.cycle" :title="item.cycle") {{ item.cycle }}
                  td.text-center
                    span {{ $t('ui.token') }}
                  template(v-for="x in Number(7)")
                    td.text-center(v-if="item['token_' + x] != null")
                      span.font-weight-bold(:title="item['token_' + x]") {{ item['token_' + x] }}
                    td.text-center(v-else)
                      span -
                  td.text-center(rowspan=2)
                    .d-flex.justify-content-center.align-items-center
                      label.custom-switch
                        input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="isEditAccess ? changedLoginStatus(item, $event) : null" :disabled="!isEditAccess")
                        span.custom-switch-indicator
                  td.text-center(rowspan=2)
                    span(:title="$t('ui.' + item.payout_method.toLowerCase())") {{ $t("ui." + item.payout_method.toLowerCase()) }}
                    template(v-if="['INBOX'].includes(item.payout_method)")
                      br
                      span.small(:title="item.campaign_id") {{ item.campaign_id }}
                  td.text-center(rowspan=2 v-if="isEditAccess")
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="onEditLogin(item)" :title="$t('ui.edit')")
                tr
                  td.text-center
                    span {{ $t('ui.cash') }}
                  template(v-for="x in Number(7)")
                    td.text-center(v-if="item['cash_' + x] != null")
                      span.font-weight-bold(:class="$helpers.fontClassName(item['cash_' + x])" :title="$n(item['cash_' + x], 'currency')") {{ $n(item['cash_' + x], 'currency') }}
                    td.text-center(v-else)
                      span -

      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th(width="10%")
                  span(:title="$t('ui.id')" ) {{ $t('ui.id') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.token')" ) {{ $t('ui.token') }}
                th.text-right(width="10%")
                  span(:title="$t('ui.target_amount')" ) {{ $t('ui.target_amount') }}
                th.text-center(width="8%")
                  span(:title="$t('ui.status')" ) {{ $t('ui.status') }}
                th.text-center(width="8%" v-if="isEditAccess")
                  span(:title="$t('ui.action')" ) {{ $t('ui.action') }} 
            tbody.clusterize-content
              tr(v-if="list.length == 0")
                td(colspan="6").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in list")
                td
                  span(:title="item.gamify_id.toUpperCase()") {{ item.gamify_id.toUpperCase() }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.token)" :title="item.token") {{ item.token }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.target_amount)" :title="$n(item.target_amount, 'currency')") {{ $n(item.target_amount, 'currency') }}
                td.text-center
                  .d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="isEditAccess ? changedStatus(item, $event) : null" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center(v-if="isEditAccess")
                  a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="onEdit(item)" :title="$t('ui.edit')")

      gamifyoperatorupdate(ref="gamifyoperatorupdate" :item="selectedGamify" @clicked="afterGamifyOperatorUpdate" @failed="handleFailed" :operatorID="operatorID")
      gamifyloginoperatorupdate(ref="gamifyloginoperatorupdate" :item="selectedGamify" @clicked="afterGamifyLoginOperatorUpdate" @failed="handleFailed" :operatorID="operatorID")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import gamifyoperatorupdate from "@/components/setup/gamifyOperatorUpdate.vue";
import gamifyloginoperatorupdate from "@/components/setup/gamifyLoginOperatorUpdate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    gamifyoperatorupdate,
    gamifyloginoperatorupdate
  },
  data: () => ({
    loading: false, 
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    list: [],
    loginList: [],
    selectedGamify: null
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_gamifyoperator");
    }
  },
  mounted: function() {},
  methods: {
    refresh() {
      this.getAllList();
    },
    getAllList() {
      this.getLoginList();
      this.getList();
    },
    getLoginList: function() {
      let url = config.getGamifyLoginOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.loginList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getList: function() {
      let url = config.getGamifyOperatorListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.list = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEdit(e) {
      this.selectedGamify = e;
      this.$refs.gamifyoperatorupdate.$refs.gamifyOperatorUpdate.show();
    },
    afterGamifyOperatorUpdate: function() {
      this.getList();
      this.$helpers.showDialog(this.$t("ui.combine.gamify_update"), this.$t("message.success"), "success");
    },
    onEditLogin(e) {
      this.selectedGamify = e;
      this.$refs.gamifyloginoperatorupdate.$refs.gamifyLoginOperatorUpdate.show();
    },
    afterGamifyLoginOperatorUpdate: function() {
      this.getLoginList();
      this.$helpers.showDialog(this.$t("ui.daily_login_update"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    },
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_gamify_status_confirm", { gamify: item.gamify_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.gamifyOperatorStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        gamify_id: item.gamify_id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedLoginStatus: function(item, eventStatus) {
      var text = ''
      if(item.gamify_id == 'login') {
        text = this.$t("message.change_gamify_daily_login_status_confirm")
      } else {
        text = this.$t("message.change_gamify_status_confirm", { gamify: item.gamify_id })
      }
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: text,
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmLoginStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmLoginStatus: function(item, status) {
      let url = config.gamifyLoginOperatorStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        gamify_id: item.gamify_id,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
  }
};
</script>